import { render } from "./profilehead.vue?vue&type=template&id=c59c2506&scoped=true"
import script from "./profilehead.vue?vue&type=script&lang=js"
export * from "./profilehead.vue?vue&type=script&lang=js"

import "./profilehead.vue?vue&type=style&index=0&id=c59c2506&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59c2506"]])

export default __exports__